import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import '../../Styles/Header.css'
import Appbar from '../../Component/NavPannel/Appbar';
import SubRoleManagementLayout from '../../Component/Layouts/SubRoleManagementLayout';

const mdTheme = createTheme();

function SubRoleManagement() {
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <Appbar mainpage="Home" subpage="Sub Role Management"/>
        <SubRoleManagementLayout />
      </Box>
    </ThemeProvider>
  );
}

export default function index() {
  return <SubRoleManagement />
}